function unite(distances) {
  return distances.reduce((acc, distanceA) => {
    const [fromA, toA] = distanceA;

    /**
     * Why use for and not reduce again?
     *
     * Simple the reduce will force me to go through the entire array again,
     * with the for I can simply return and break the cycle at the beginning
     * in the best case scenario but in the worst scenario it is 6 for half a dozen.
     * But the reduce would have another problem, I would need a break controller
     * to understand that `distanceA` has already been processed or not.
     */
    // eslint-disable-next-line no-restricted-syntax
    for (const distanceB of acc) {
      const [fromB, toB] = distanceB;

      if (fromA <= fromB) {
        if (toA >= fromB) {
          const end = new Date(Math.max(toA.getTime(), toB.getTime()));

          acc.splice(acc.indexOf(distanceB), 1, [fromA, end]);

          return acc;
        }
      }

      if (toA >= toB) {
        if (fromA <= toB) {
          const start = new Date(Math.min(fromA.getTime(), fromB.getTime()));

          acc.splice(acc.indexOf(distanceB), 1, [start, toA]);

          return acc;
        }
      }

      if (fromA >= fromB && toA <= toB) return acc;
    }

    return [...acc, distanceA];
  }, []);
}

export default function uniteDistancesWithSimilarity(distances) {
  let unity = unite(distances);

  /**
   * Do what eslint? that is it!
   */
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const maybePerfect = unite(unity);

    if (maybePerfect.length === unity.length) return maybePerfect;

    unity = maybePerfect;
  }
};
